"use client";

import React from "react";

const ReliableToothExtractions: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Reliable Tooth Extractions in Astoria Queens
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          When you need a tooth removed, you deserve a dentist who takes the
          time to explain your options, answer your questions, and make the
          process as smooth as possible. At Smile4Me, every tooth extraction
          begins with a thorough exam and X-rays so Dr. Khaimov can assess the
          tooth, review the surrounding bone structure, and confirm that
          removal is the right course of action. If there&apos;s a way to save
          the tooth, he&apos;ll tell you. If extraction is the best path
          forward, he&apos;ll walk you through exactly what to expect, before,
          during, and after the procedure.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          We treat patients from across Astoria, Long Island City, Jackson
          Heights, Woodside, Sunnyside, and the greater Queens area, and we
          accept most PPO insurance plans to make care as accessible as
          possible.
        </p>
      </div>
    </section>
  );
};

export default ReliableToothExtractions;
